import styled from 'styled-components';
import { COMMON, TYPOGRAPHY } from './constants';
import sx from './sx';
var Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-1s3uzov-0"
})(["", ";", ";", ";"], TYPOGRAPHY, COMMON, sx);
export default Text;